import React from 'react';
import { Redirect } from 'react-router-dom';

const RegisterSuccess = () => {
	return <Redirect to='/preapproval' />;
};

export default RegisterSuccess;
